var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "text-white" }, [
    _c("h1", { staticClass: "text-white" }, [
      _c("i", { staticClass: "far fa-style lh-inherit" }),
      _vm._v(" " + _vm._s(_vm._f("trans")("Choose a Style")) + "\n  "),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "text-white" }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm._f("trans")(
              "Ever dreamed of capturing the essence of a Renaissance masterpiece ? Or perhaps you want to unleash the vividness of abstract expressionism ?"
            )
          ) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "text-white" }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm._f("trans")(
              "Select from a variety of renowned art styles, ranging from classical to contemporary, and watch as our AI - powered engine transforms your ideas into stunning visual masterpieces."
            )
          ) +
          "\n  "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }